module.exports = __webpack_public_path__ + "static/img/xcx_xy.fd573455.jpeg";